import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import FileUploadButton from 'components/button/FileUploadButton';
import Header from 'components/ui/general/Header';
import PointsOfInterestList from 'pages/pointsofinterest/list/PointsOfInterestList';
import Title from 'components/ui/general/Title';
import { createPointOfInterestImport } from 'store/actions/pointsofinterest/createPointsOfInterest';
import translate from 'components/hoc/translate';

const PointsOfInterestListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.points_of_interest.title') } />

                <Actions>
                    <FileUploadButton
                        acceptedFormat='text/csv'
                        action={ createPointOfInterestImport }
                        buttonTitle={ translate('resources.points_of_interest.import.dropzone.title') }
                        dialogTitle={ translate('resources.points_of_interest.import.title') }
                        dropzoneDescription={ translate('resources.points_of_interest.import.dropzone.description') }
                        title={ translate('actions.import') }
                    />

                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <PointsOfInterestList
                { ...props }
            />
        </div>
    );
};

PointsOfInterestListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(PointsOfInterestListContainer);



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/list/PointsOfInterestListContainer.js